import React from 'react'
import PropTypes from 'prop-types'
import { Center, Logotype, Content } from './styles'

const CubsecHeader = ({ children }) => (
  <Center>
    <Logotype />
    {children ? (
      <Content>
        {children}
      </Content>
    ) : null}
  </Center>
)

export default CubsecHeader

CubsecHeader.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element)
}

CubsecHeader.defaultProps = {
  children: null
}